import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { service_url } from "./service-url";

@Injectable({
  providedIn: 'root'
})
export class DoctorService {
  api_url: any
  constructor(private http: HttpClient) {
    this.api_url = service_url.api_url
  }

  getDoctors(filters = {}) {
    let params = new HttpParams();
    Object.keys(filters).forEach(function (key) {
      params = params.append(key, filters[key]);
    });
    return this.http.get(this.api_url + '/doctors', { params: params })
  }

  showDoctor(doctor_id) {
    return this.http.get(this.api_url + '/doctors/' + doctor_id)
  }

  submitDoctor(params, id = '') {


    if (id != '') {
      return this.http.put(this.api_url + '/doctors/' + id, params)
    }
    else {
      return this.http.post(this.api_url + '/doctors', params)
    }
  }

  deleteDoctor(doctor_id) {
    return this.http.delete(this.api_url + '/doctors/' + doctor_id)
  }
}
